// extracted by mini-css-extract-plugin
module.exports = {"root":"TextWithIconBlock_root__4gYSF","content":"TextWithIconBlock_content__f75Uf","cardTitle":"TextWithIconBlock_cardTitle__6ctsy","iconWrap":"TextWithIconBlock_iconWrap__NWjLH"};